import { useState } from 'react';
import { useMutation, gql } from '@apollo/client';

export const UPDATE_CONTACT = gql`
mutation updateContact($contact: UpdatePartnerContactInput!) {
    updateContact(contact: $contact) {
        type,
        lpsContact {
            joinId
        },
        vrboContact {
            autoAuthUrl,
            userPublicUuid,
            newSupplier
        }
    }
}
`;

const useUpdateContact = ({ onCompleted, onError }) => {
    const [updateContact] = useMutation(UPDATE_CONTACT, { onCompleted, onError });
    const [inFlight, setInFlight] = useState(false);

    const submitContact = async ({
        password,
        phoneCountryCode,
        phoneCountryCodeDigits,
        phoneNumber,
        locale,
        fingerprint,
        duaid
    }) => {
        setInFlight(true);
        let trustPayload = '';
        /* istanbul ignore else */
        if (typeof window === 'object') {
            trustPayload = window.trustApi?.getTrustPayload();
        }

        const contact = {
            type: 'FRBO', // This is always the case for missing details.
            password: password || '',
            phoneCountryCode: phoneCountryCode || '',
            phoneCountryCodeDigits: phoneCountryCodeDigits || '',
            phoneNumber: phoneNumber || '',
            locale,
            fingerprint,
            trustPayload,
            duaid,
            source: 'MISSING DETAILS'
        };

        await updateContact({
            variables: {
                contact
            }
        });
    };

    return { submitContact, inFlight };
};

export default useUpdateContact;
